import gql from 'graphql-tag'

import { ITag } from '../../../../types/Tag'

export interface IVariables {
  eventId: number
  tagId: number
}

export interface IResponse {
  admin: {
    event: {
      removeTag: number
    }
  }
}

export type IOperationResult = ITag[]

export const REMOVE_TAG_MUTATION = gql`
  mutation removeTagFromEvent($eventId: PositiveInt!, $tagId: PositiveInt!) {
    admin {
      event(id: $eventId) {
        id
        removeTag(id: $tagId)
      }
    }
  }
`
